
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const GpsAction = (props) => {
    const handleEventClick = (e) => {
        e.stopPropagation();
        //console.log("Overspeed ",props);
        props.context.componentParent.onShowTransitKpi(props);
    };
    
   
            var colr = 'grayfont'
       
    //}
    return (
        <div>
            <button onClick={handleEventClick} className="custom-btn f22 label label-success" 
            title="GPS Data Available" ><i className={"icofont icofont-social-google-map "+(colr)}></i> &nbsp;</button>
            
        </div>
    );
};

export default GpsAction;
